import { StyledEngineProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import initializeStore from '../store';
import { queryClient } from '../store/queryClient';
import { FeatureProvider } from './components/FeatureProvider';
import { ActiveRoleProvider } from './context/ActiveRoleContext';
import { NavigationMenuProvider } from './context/NavigationMenuContext';
import AppContainer from './scenes/App';

const store = initializeStore();

const App = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ActiveRoleProvider>
          <FeatureProvider>
            <NavigationMenuProvider>
              <AppContainer />
            </NavigationMenuProvider>
          </FeatureProvider>
        </ActiveRoleProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  </Provider>
);

export default App;
